/** Maintenance and Parts moved to servicing.sailgp.tech at the 2026-09-28
 * cutover, on the same paths (/maintenance/..., /parts/...,
 * /boats/:boatId/parts). Override with VITE_SERVICING_URL, e.g. the local
 * servicing dev server. */
export const SERVICING_URL: string =
  import.meta.env.VITE_SERVICING_URL || "https://servicing.sailgp.tech";

/** The same page on servicing, keeping the query string and hash. Pure, so it
 * is unit-tested. */
export function servicingUrl(pathname: string, search = "", hash = "", base = SERVICING_URL): string {
  return `${base.replace(/\/+$/, "")}${pathname}${search}${hash}`;
}
